module.exports = __webpack_public_path__ + "img/instagram.c7b7097a.png";